<template>
  <div class="loading" role="status" aria-live="polite">
    <span class="dot" aria-hidden="true"></span>
    <span>{{ label }}</span>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, default: 'Loading…' },
})
</script>

<style scoped>
.loading {
  width:100%;
  height:100%;
  min-height:180px;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
  color:#93a0b4;
  font-size:12px;
  font-weight:800;
}
.dot {
  width:7px;
  height:7px;
  border-radius:999px;
  background:currentColor;
  animation:pulse 1.1s ease-in-out infinite;
}
@keyframes pulse {
  0%,100% { opacity:.35; transform:scale(.85); }
  50% { opacity:1; transform:scale(1); }
}
</style>
